import { type TOC } from '@ember/component/template-only';
import fuiDropdown from 'wise-fui-modules/modifiers/fui-dropdown';
import type { WithBoundArgs as WBA } from '@glint/template';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';

interface ItemSignature {
  Element: HTMLDivElement;
  Args: {
    dataTestValue?: string;
    /** Used for the data-test or to be a parameter for the default action */
    key: string | undefined;
    /** The action to call when clicked provided by the DropdownButton */
    onClick: (item?: string) => void;
  };
  Blocks: { default: [] };
}

const dropdownButtonBaseButtonItem: TOC<ItemSignature> = <template>
  <div
    class='item'
    role='button'
    data-test={{if @dataTestValue @dataTestValue @key}}
    {{on 'click' (fn @onClick @key)}}
    ...attributes
  >
    {{yield}}
  </div>
</template>;

export interface Signature {
  Element: HTMLDivElement;
  Args: {
    onClick?: (item?: string) => void;
    alignMenuLeft?: boolean;
  };
  Blocks: {
    label: [];
    button: [];
    items: [WBA<typeof dropdownButtonBaseButtonItem, 'onClick'>];
  };
}

const DropdownButtonBaseComponent: TOC<Signature> = <template>
  <div ...attributes>
    <div class='flex flex-col gap-2'>
      <div class='text-p1 text-grey'>
        {{yield to='label'}}
      </div>

      <div
        {{fuiDropdown action='hide' transition='drop'}}
        class='ui floating dropdown item [&.ui.floating.dropdown.item]:ml-auto [&.ui.floating.dropdown.item]:w-[max-content]'
      >
        {{yield to='button'}}
        <div class='menu {{if @alignMenuLeft "left"}}'>
          {{yield
            (component dropdownButtonBaseButtonItem onClick=@onClick)
            to='items'
          }}
        </div>
      </div>
    </div>
  </div>
</template>;

export default DropdownButtonBaseComponent;
